module.exports = __webpack_public_path__ + "static/media/pie.ce2d220d.svg";